<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='../../../zgloszenie/skladanie-wniosku'
         aria-label='Zgłoszenie'>
        eUsterka / Zgłoszenie
      </a>
    </li>
    <li>
      Potwierdzenie wysłania
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert type="success" [closable]="false">
      Zgłoszenie zostało wysłane!
    </app-alert>
    <h2>
      Potwierdzenie wysłania
    </h2>
    <div class="application-details">
      <div class="row">
        <div class="col-md-4">
          <app-label label="Kategoria zgłoszenia:">
            {{ report?.category || '-' }}
          </app-label>
        </div>
      </div>
      <br>
      @if (mapImage) {
        <h3>
          Lokalizacja
        </h3>
        <div class="row">
          <div class="col-md-4">
            <app-label label="Pobierz:">
              <a href="#" (click)="onDownloadAttachment($event, mapImage)">{{ mapImage.originalName }}</a>
            </app-label>
          </div>
        </div>
        <br>
      }
      @if (report?.description; as notes) {
        <div class="row">
          <div class="col-12">
            <app-label label="Opis zgłoszenia:">
              {{ notes }}
            </app-label>
          </div>
        </div>
        <br>
      }
      <h3>
        Dane zgłaszającego
      </h3>
      <div class="row">
        <div class="col-md-4">
          <app-label label="Imię/Imiona:">
            {{ report?.firstName || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Nazwisko:">
            {{ report?.lastName || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="Numer telefonu:">
            {{ report?.phone || '-' }}
          </app-label>
        </div>
        <div class="col-md-4">
          <app-label label="E-mail:">
            {{ report?.email || '-' }}
          </app-label>
        </div>
      </div>
      <br>
      @if (showAttachments) {
        <h3>
          Zdjęcia
        </h3>
        <div class="row">
          <ol>
            <li>
              @if (photo1; as photo) {
                <app-label label="Zdjęcie:">
                  <a href="#" (click)="onDownloadAttachment($event, photo)">{{ photo?.originalName }}</a>
                </app-label>
              } @else {
                <app-label label="Zdjęcie:">brak</app-label>
              }
            </li>
            <li>
              @if (photo2; as photo) {
                <app-label label="Zdjęcie:">
                  <a href="#" (click)="onDownloadAttachment($event, photo)">{{ photo?.originalName }}</a>
                </app-label>
              } @else {
                <app-label label="Zdjęcie:">brak</app-label>
              }
            </li>
            <li>
              @if (photo3; as photo) {
                <app-label label="Zdjęcie:">
                  <a href="#" (click)="onDownloadAttachment($event, photo)">{{ photo?.originalName }}</a>
                </app-label>
              } @else {
                <app-label label="Zdjęcie:">brak</app-label>
              }
            </li>
          </ol>
        </div>
      }
    </div>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        routerLink="/">
        <span>
          Wróć na stronę główną
        </span>
      </button>
    </div>
  </section>
</app-content>
